import * as React from 'react';
import { observer } from 'mobx-react-lite';
import TimestreamSearchResult from './TimestreamSearchResult';
import searchItems from '../selectors/searchItems';
import { FocusZone } from '@fluentui/react/lib/FocusZone';
import { List } from '@fluentui/react/lib/List';
import type { SearchResultItem } from 'owa-timestream-asset-search';

export default observer(function Results() {
    const onBeforeFocus = React.useCallback((childElement: HTMLElement) => {
        // persona cards are forcily marked focusable, avoid actually focusing them
        return childElement.tagName.toLowerCase() !== 'span';
    }, []);

    return (
        <FocusZone onBeforeFocus={onBeforeFocus}>
            <List items={searchItems()} onRenderCell={renderCell} />
        </FocusZone>
    );
});

function renderCell(item: SearchResultItem, index: number): JSX.Element {
    return <TimestreamSearchResult highlightSearchTerms={true} item={item} key={index} />;
}
